import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { FelderQuerySorterConfig } from 'fa-kt.types';
import { FelderService } from '../service';

@Component({
  selector: 'fa-kt-felder-sorter',
  templateUrl: './felder-sorter.component.html',
  styleUrls: ['./felder-sorter.component.css'],
})
export class FelderSorterComponent {
  public FelderSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public felder: FelderService,
  ) {
    this.FelderSorterConfig = FelderQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
